import { render, staticRenderFns } from "./NewCustomerScan.vue?vue&type=template&id=a7b3916e&"
import script from "./NewCustomerScan.vue?vue&type=script&lang=ts&"
export * from "./NewCustomerScan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports